export const MODE_DEV = 'DEV'
export const MODE_PROD = 'PROD'

export const FIREBASE_API_KEY = 'AIzaSyBQGTqJTK2hbOFy8qXG7RJyR3uqEVHGW6w'
export const FIREBASE_AUTH_DOMAIN = 'verda-living-skies.firebaseapp.com'
export const FIREBASE_DATABASE_URL = 'https://verda-living-skies.firebaseio.com'
export const FIREBASE_PROJECT_ID = 'verda-living-skies'
export const FIREBASE_STORAGE_BUCKET = 'verda-living-skies.appspot.com'
export const FIREBASE_MESSAGING_SENDER_ID = '193724844336'
export const BRAND_ID = '-LdGovm0Jpn5TycB8DkU'
export const APP_NAME = 'Living Skies Cannabis - Online Store'
export const GOOGLE_TRACKING_ID = 'UA-140384535-2'
export const GA_DEBUG = false
export const APP_ID = '1:193724844336:web:5714f07433727be7'
export const MEASUREMENT_ID = 'G-B2N3D8K0P4'

export const FIREBASE_DB_MODE = 'DEV'
export const FIREBASE_SUPER_ADMIN_EMAIL = 'andres+livingskies.admin@verda.ca'
